import AWS from 'aws-sdk';
import axios from 'axios';

// AWS RDS connection
AWS.config.update({
  region: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
});

const rds = new AWS.RDS();

// API client setup with environment-aware configuration
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'development' 
    ? 'http://localhost:5000'
    : 'https://api.causeandimpact.org',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to handle auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Remove any CORS headers from the request
  // The server will handle CORS configuration
  delete config.headers['Access-Control-Allow-Origin'];
  delete config.headers['Access-Control-Allow-Methods'];
  delete config.headers['Access-Control-Allow-Headers'];
  
  return config;
});

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API request failed:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      error: error.message
    });
    throw error;
  }
);

export { rds, api }; 